"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = exports.Circle = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var spin = (0, _styledComponents.keyframes)(["0%{transform:rotate(0);}100%{transform:rotate(360deg);}"]);
var translucent = 'rgba(0, 0, 0, 0.1)';
var Spinner = exports.Spinner = _styledComponents["default"].div.withConfig({
  displayName: "styles__Spinner",
  componentId: "sc-140ik0e-0"
})(["display:inline-block;"]);
var Circle = exports.Circle = _styledComponents["default"].div.withConfig({
  displayName: "styles__Circle",
  componentId: "sc-140ik0e-1"
})(["animation:0.8s linear infinite ", ";border-color:", " ", " ", ";border-radius:50%;border-style:solid;border-width:2px;display:block;height:", ";width:", ";", ";", ";", ";"], spin, function (p) {
  return p.color ? p.color : p.theme.mainColor;
}, translucent, translucent, function (p) {
  return p.size;
}, function (p) {
  return p.size;
}, function (p) {
  return (p.center || p.centerX) && "\n    margin-left: calc(".concat(p.size, " / -2);\n  ");
}, function (p) {
  return (p.center || p.centerY) && "\n    margin-top: calc(".concat(p.size, " / -2);\n  ");
}, function (p) {
  return p.centerAbs && "\n    left: 50%;\n    position: absolute;\n    top: 50%;\n  ";
});
//# sourceMappingURL=styles.js.map